import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

export const MyTimesheetStyledCalendarTooltip = styled(
  ({
    className,
    ...props
  }: React.ComponentProps<typeof Tooltip> & { className?: string }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ),
)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.darkBase.main,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.darkBase.main,
    borderRadius: "8px",
    padding: "12px 8px",
  },
}));

export default MyTimesheetStyledCalendarTooltip;
